import { render, staticRenderFns } from "./GyroView7.vue?vue&type=template&id=236406c2&scoped=true&lang=pug&"
import script from "./GyroView7.vue?vue&type=script&lang=js&"
export * from "./GyroView7.vue?vue&type=script&lang=js&"
import style0 from "./GyroView7.vue?vue&type=style&index=0&id=236406c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236406c2",
  null
  
)

export default component.exports